<template>
  <div class="p-6">
    <div class="max-w-xl mx-auto">
      <div class="card">
        <div class="p-12">
          <h1 class="mb-6 text-2xl font-bold">
            Customise your branding
          </h1>
          <form @submit.prevent="submit">
            <fieldset class="form-group">
              <label for="" class="form-label">
                Subdomain
              </label>
              <div class="relative mt-1">
                <input type="text" placeholder="your-company-name" class="form-input" v-model="$parent.form.subdomain" autofocus @input="slugifySubdomain" @blur="checkSubdomain">
                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <span class="text-gray-400">
                    .flt.onl
                  </span>
                </div>
              </div>
              <validations field="subdomain" :errors="errors" />
              <div class="mt-2 text-sm leading-tight text-gray-500">
                <div>Only lowercase letters, numbers and hyphens (-) are allowed. Minimum of 4 characters long and can't start or end with a hyphen.</div>
                <div class="mt-2" v-show="$parent.form.subdomain">
                  Customers will be able to access your portal at <br> <strong>https://{{ $parent.form.subdomain }}.flt.onl</strong>
                </div>
              </div>
            </fieldset>
            <fieldset class="form-group">
              <label for="color" class="form-label">Brand Colour</label>
              <div class="grid grid-cols-2 gap-1 sm:grid-cols-3">
                <label class="relative flex items-center justify-center bg-gray-100 rounded cursor-pointer hover:bg-gray-50" :for="key" v-for="(value, key) in $store.state.colors" :key="key">
                  <input type="radio" name="brandColor" v-model="$parent.form.color" :value="key" :id="key" class="absolute opacity-0 pointer-events-none">
                  <div class="flex items-center justify-start w-full h-8 p-2">
                    <div class="flex items-center justify-center w-4 h-4 mr-2 text-xs text-white rounded" :style="{ 'background': `rgb(${value})` }" >
                      <div v-if="$parent.form.color === key">✓</div>
                    </div>
                    <div class="text-sm font-medium text-gray-800 truncate">
                      {{ key | capitalize }}
                    </div> 
                  </div>
                </label>
              </div>
            </fieldset>
            <button type="submit" class="w-full mt-2 btn btn-lg btn-primary" v-submitting="submitting">
              Save Branding &rarr;
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import slugify from 'slugify'

export default {
  name: 'OnboardingBrand',

  created () {
    if (this.$parent.form.subdomain === '') {
      this.$parent.form.subdomain = slugify(this.$parent.form.name, { lower: true, remove: /[*+~.()'"!:@]/g })
    }
  },

  data () {
    return {
      submitting: false,
      errors: []
    }
  },

  methods: {
    async submit () {
      this.submitting = true
      let array = []
      
      if (!this.$parent.form.subdomain) {
        array.push({ 
          field: 'subdomain', 
          rule: 'subdomain_required', 
          message: `You must enter a subdomain`
        })
      } 

      if (await this.checkSubdomain() === 'true') {
        array.push({ 
          field: 'subdomain', 
          rule: 'subdomain_unique', 
          message: `Sorry that subdomain is taken. Please enter another.`
        })
      }

      this.errors = array

      if (!this.errors.length) {
        try {
          this.$parent.createAccount()
        } catch (error) {
          console.error(error)
        } finally {
          this.submitting = false
        }
      } else {
        this.submitting = false
      }
    },

    slugifySubdomain () {
      this.$parent.form.subdomain = this.$parent.form.subdomain.toLowerCase().replace(/[^a-z0-9-]+/g, '')
    },

    async checkSubdomain () {
      const subdomainExists = await this.$api.get(`subdomains/${this.$parent.form.subdomain}`)
      return subdomainExists
    }
  }
}
</script>